import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'

export default createUseStyles(
  (theme: Theme) => ({
    root: {
      userSelect: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 24,
      gap: 24,
      [forTabletPortraitUp]: {
        paddingTop: 16,
        gap: 32,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    imageContainer: {
      margin: 'auto',
    },
    image: {
      maxWidth: 232,
    },
    textContainer: {
      margin: [32, 16, 16],
      textAlign: 'center',
    },
    message: {
      ...typography['Lato Body 2'],
    },
    link: {
      ...typography['Lato Link 2'],
      display: 'block',
      color: theme.palette.primary.main,
      [forPhoneOnly]: {
        display: 'inline',
        marginLeft: 4,
      },
    },
  }),
  { name: 'EmptyPeriodMsg' }
)
